import { apiClientGeral, apiCallCenter } from '@/plugins/axios'

export default {
  getRotas() {
    return apiClientGeral().get('/rotas/lazy')
  },
  getFilas() {
    return apiCallCenter().get('/queue/lazy')
  },
  getOperadores() {
    return apiCallCenter().get('/agent')
  },
  getOperador(id) {
    return apiCallCenter().get(`/agent/${id}`)
  },
  postOperador(operador) {
    return apiCallCenter().post('/agent', operador)
  },
  putOperador(id, operador) {
    return apiCallCenter().put(`/agent/${id}`, operador)
  },
  deleteOperador(id) {
    return apiCallCenter().delete(`/agent/${id}`)
  },
  getDepartamentos() {
    return apiCallCenter().get('/agent/departamentos/lazy')
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas/lazy')
  },
  getOperadoresMonitor() {
    return apiCallCenter().get('/agent/ramais/lazy')
  },
}
